export const enum CommunicationType {
    ArchivedDocuments,
    Emails,
    SMS
}
